import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Icon } from 'edcom-ui';
import AppLink from '../links/AppLink';

import styles from './Breadcrumbs.module.less';
import RequestContext from '../../services/RequestContext';

export default function Breadcrumbs({
  breadcrumbNodes = [],
  className,
  ...otherProps
}) {
  const { hostname } = useContext(RequestContext);

  const links = [
    {
      url: '/resources/',
      display: 'All Subjects',
    },
  ];

  for (let breadcrumbNode of breadcrumbNodes) {
    links.push({
      url: '/resources/' + breadcrumbNode.path,
      display: breadcrumbNode.text,
    });
  }

  return (
    <div className={clsx(styles.container, className)} {...otherProps}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: links.map(({ url, display }, i) => {
              const listItem = {
                '@type': 'ListItem',
                position: i + 1,
                name: display,
              };

              if (url) {
                listItem.item = `https://${hostname}${url}`;
              }

              return listItem;
            }),
          }),
        }}
      />

      <div className={styles.breadcrumbsIcon}>
        <img
          src="https://cdn.education.com/files/static/content/breadcrumbs_icon.svg"
          alt=""
        />
      </div>

      <div className={styles.breadcrumb}>
        {links.map(({ url, display }, index) => {
          if (!url) {
            return (
              <span className={styles.link} key={display}>
                {display}
              </span>
            );
          }

          return (
            <React.Fragment key={url}>
              {index > 0 && (
                <Icon
                  name="right-open"
                  className={styles.rightOpen}
                  isImg={false}
                />
              )}
              <AppLink
                href={url}
                className={clsx(
                  styles.link,
                  index === links.length - 1 && styles.last
                )}
              >
                {display}
              </AppLink>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}

Breadcrumbs.propTypes = {
  breadcrumbNodes: PropTypes.array.isRequired,
  className: PropTypes.string,
};
